import { Col, Container, Row } from "react-bootstrap";

import { useSession } from "../../contexts/SessionContext";
import { PermissionComponent } from "../../services/PermissionGuard";
import translate from "../../services/Translate";
import DelayedCohorts from "./components/DelayedCohorts/DelayedCohorts";
import LatestDemo from "./components/LatestDemo/LatestDemo";
import SavedUrls from "./components/SaveUrls/SaveUrls";

const Home = () => {
  const { language } = useSession();

  return (
    <div className="d-flex flex-column">
      <Container className="py-3 py-md-4">
        <div className="mb-3">
          <h1 className="mb-2">{translate(language, "PAGES.HOME.TITLE")}</h1>
        </div>
        <PermissionComponent neededPermission={[{ methods: ["GET"], route: "/cohorts/delayed" }]}>
          <DelayedCohorts />
        </PermissionComponent>
        <Row>
          <Col xs={12} md={10} lg={6}>
            <PermissionComponent neededPermission={[{ methods: ["GET"], route: "/demos/records/latest" }]}>
              <LatestDemo />
            </PermissionComponent>
          </Col>
          <Col xs={12} md={10} lg={6} className="mt-3 mt-lg-0">
            <SavedUrls />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Home;
